export function getDefined<T>(x: T | undefined, message?: string): T {
  if (x === undefined) {
    throw new Error(message || 'got undefined value, but expected defined');
  }
  return x;
}
